<template>
    <div id="map-container" class="map-component">
        <LayerOptionsComponent class="map-component-btn-layer" @update:style="updateStyleMap" />

        <q-btn v-if="show_save_control" class="map-component-btn-save" square icon="save" title="Guardar trazado"
            @click="saveLineString" />
    </div>
</template>

<script lang="ts">
import MapComponent from './MapComponent';
export default MapComponent;
</script>

<style lang="scss" src="./MapComponent.scss"></style>